export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/topojson-client/src/identity.js
// module id = 165
// module chunks = 0